import ShiftDeclinedReason from "@/models/Shared/ShiftDeclinedReason";

export default class ShiftDeclinedReasonViewModel {
    name: string;
    value: ShiftDeclinedReason;
    public constructor(name: string, value: ShiftDeclinedReason) {
        this.name = name;
        this.value = value;
    }
}